import { useState } from "react";

export const views = {
  addNewReferral: "addNewReferral",
  refferalOverview: "refferalOverview",
  general: "general",
};

export const useView = () => {
  return useState(views.general);
};
